import { ExamGradingStatus } from '@exam-center/graphql';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { AssignmentTurnedInOutlinedIcon, Box, Button, Text, Tooltip } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { useExamEventDetails } from '../../providers';
import { ImportExamineeAnswersFormModal } from '../import-examinee-answers-form-modal';

interface ImportExamineeAnswersButtonProps {
  tooltipText?: React.ReactNode;
  disabled?: boolean;
  examEventId: string;
}

export default function ImportExamineeAnswersButton(
  props: Readonly<ImportExamineeAnswersButtonProps>,
) {
  const { tooltipText, disabled: isDisabled, examEventId } = props;

  const {
    examEvent: {
      metadata: { examGradingStatus },
    },
  } = useExamEventDetails();

  const [isImportAnswerModalOpen, { open: openImportAnswerModal, close: closeImportAnswerModal }] =
    useDisclosure(false);

  const isGradingCompleted = examGradingStatus === ExamGradingStatus.Completed;

  if (isGradingCompleted) {
    return null;
  }

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.UPDATE}>
      <Tooltip
        disableHoverListener={!isDisabled}
        title={
          tooltipText ? (
            tooltipText
          ) : (
            <Text variant='captionSemibold'>
              ไม่สามารถตรวจข้อสอบได้
              <br />
              เนื่องจากการสอบยังไม่สิ้นสุด
            </Text>
          )
        }
        arrow
      >
        <Box>
          <Button
            size='medium'
            disabled={isDisabled}
            onClick={openImportAnswerModal}
            startIcon={<AssignmentTurnedInOutlinedIcon />}
          >
            <Text variant='body2Semibold'>ตรวจข้อสอบ</Text>
          </Button>
        </Box>
      </Tooltip>
      <ImportExamineeAnswersFormModal
        open={isImportAnswerModalOpen}
        onClose={closeImportAnswerModal}
        examEventId={examEventId}
      />
    </WithPermission>
  );
}
